import { Component, OnDestroy, OnInit, input, output } from '@angular/core';
import { UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { debounceTime, distinctUntilChanged, map, Subscription, tap } from 'rxjs';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';

@Component({
    selector: 'app-search-filter[searchProps]',
    template: `
    <mat-form-field appearance="outline">
      <mat-label>Search</mat-label>
      <input matInput [formControl]="search" />
    </mat-form-field>
  `,
    imports: [MatFormField, MatLabel, MatInput, FormsModule, ReactiveFormsModule]
})
export class SearchFilterComponent implements OnInit, OnDestroy{
  readonly searchProps = input.required<string[]>();
  readonly searchChange = output<string>();
  
  search = new UntypedFormControl('');
  private sub!: Subscription;

  constructor() {}

  // ?filter={"$or":[{"email":{"$regex":"^${value}"}}, {"name": {"$regex": "^${value}"}}, .....]}
  ngOnInit(): void {
    const searchSub = this.search.valueChanges.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(search => {
        let query = '';
        if(search) {
          const fields = this.searchProps().map(prop => `{"${prop}":{"$regex":"^${search}"}}`).join(',');
          query = `"$or":[${fields}]`;
        }
        return query;
      }),
      tap(value => this.searchChange.emit(value))
    ).subscribe()

    this.sub = searchSub;
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }


}
